import {modalCommentLink} from "./hoc/modalCommentLink";

const WaybillV2BulkResponsiblePersonTillReturn = modalCommentLink("WaybillV2BulkResponsiblePersonTillReturn")
export default WaybillV2BulkResponsiblePersonTillReturn